export const cacheTags = {
    REQUESTS: 'Requests'
}